import {combineReducers} from 'redux';

const INIT_STATE = {
  selectlanguage:'ar'
}


const selectedLanguageReducer = (state=INIT_STATE, action) =>
{
  if(action.type === 'LANG_SELECTED')
     return {...state,selectedlanguage:action.payload}

return state;
};

export default combineReducers({
 selectlanguage: selectedLanguageReducer
});
